/**
 * External Dependencies
 */
import 'jquery';
import { Swiper, Navigation, Pagination, Autoplay } from 'swiper';
import 'waypoints/lib/jquery.waypoints';
import 'jquery.counterup';
import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import Cookie from 'js-cookie';


const WebFont = require('webfontloader');

let webFontConfig = {
    custom: {
        families: ['Lato:400,400i,700,700i'],
        urls: [app.publicPath + '/styles/fonts.css',],
    },
    active: function () {
        sessionStorage.fonts = true;
    }
};
// console.log(webFontConfig);

WebFont.load(webFontConfig);
Swiper.use([Navigation, Pagination, Autoplay]);

// cssVars();

Number.isNaN = Number.isNaN || function (value) {
    return value !== value;
}

jQuery(() => {

    $(window).load(function () {
        // Remove the # from the hash, as different browsers may or may not include it
        let hash = location.hash.replace('#', '');
        if (hash != '') {
            let $target = $(window.location.hash);
            $target = $target.length ? $target : $('[name=' + window.location.hash.substr(1) + ']');
            smoothScrollTo($target);
        }
    });

    let smoothScrollTo = (target) => {
        // setTimeout(function () {
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - $('.page-header').outerHeight() + 70
            }, 250);
            return false;
        }
        // }, 0);
    }

    $('a[href*="#"]:not([href="#"])').on('click', function (e) {
        let href = $(this).attr('href');
        if (location.pathname === href.replace(/#(.*)/, '')) {
            e.preventDefault();
        }
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let $target = $(this.hash);
            $target = $target.length ? $target : $('[name=' + $(this.hash).slice(1) + ']');

            smoothScrollTo($target);
        }
    });

    /** check for IE */
    if (window.matchMedia('@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)').matches) {
        $('html').addClass('ie');
    }

    let initHambugerMenu = function () {
        $(".o-navbar__burger").off('click');
        $('.o-navbar__item.has-dropdown').off('click');

        let isVisible = $('.o-navbar__burger').is(':visible');
        let isSmall = window.matchMedia('(max-width: 48em)').matches;
        if (isSmall || isVisible) {
            $(".o-navbar__burger").on('click', function () {
                $(".o-navbar__burger").toggleClass("is-active");
                $(".o-navbar__menu").toggleClass("is-active");

                $('html').toggleClass('is-clipped');
            });

            $('.o-navbar__item.has-dropdown').on('click', '> .o-navbar__link, > .o-navbar__item', function (e) {
                // console.log("click drop");
                e.preventDefault();
                $(this).parent().toggleClass('is-active');

            });
        } else {
            // init fancybox for
        }
    };

    initHambugerMenu();
    $(window).on('resize', initHambugerMenu);

    const swiper = new Swiper('.slider-hero', {
        speed: 500,
        autoplay: {
            delay: 6500,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            // renderBullet: function (index, className) {
            //     // console.log("render");
            //     // class="swiper-pagination-bullet swiper-pagination-bullet-active"
            //     return '<span class="' + className + '"><span></span></span>';
            // }
        },
    });

    if ($('.slider-iconlist').length) {
        // console.log('slider iconlist');
        let slidesPerView = $('.slider-iconlist').data('slides-per-view');

        const swiper = new Swiper('.slider-iconlist', {
            slidesPerView: slidesPerView,
            spaceBetween: 28,
            speed: 500,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                480: {
                    slidesPerView: 2,
                },
                720: {
                    slidesPerView: 3,
                },
            }
        });
    }

    $('[data-fancybox]').fancybox({
        onActivate: function (instance, slide) {
            $('html').addClass('is-clipped');
        },
        afterClose: function (instance, slide) {
            $('html').removeClass('is-clipped');
        },
    });

    // const counters = document.querySelectorAll('.count-up');
    // const speed = 1000;
    // counters.forEach(counter => {
    //     const updateCount = () => {
    //         const target = counter.getAttribute('data-target');
    //         // split by , or .
    //     }
    // });
    // Start counting, do this on DOM ready or with Waypoints.
    // const counters = document.querySelectorAll('.count-up');
    // counters.forEach(counter => {
    //     counterUp(counter, {
    //         duration: 1000,
    //         // delay: 16,
    //     });
    // });

    $('.count-up:contains(",")').counterUp({
        delay: 10,
        time: 1000,
        formatter: function (n) {
            return n.replace(/,/g, '.');
        }
    });

    $('.count-up:contains(".")').counterUp({
        delay: 10,
        time: 1000,
        formatter: function (n) {
            return n.replace(/\./g, ',');
        }
    });

    $('.count-up:not(:contains(.)):not(:contains(,))').counterUp({
        delay: 10,
        time: 1000,
        formatter: function (n) {
            return n.replace(/\./g, ',');
        }
    });

    $(document).on('click', '.nl2go-widget button[type="submit"]', function (e) {
        let $n2g_privacy = $(this).parents('.nl2go-widget').find('.legal');
        let $n2g_checkbox = $(this).parents('.nl2go-widget').find('input[type="checkbox"]');
        let $n2g_label = $n2g_checkbox.next('label');

        if ($n2g_checkbox.not(':checked').length) {
            $n2g_privacy.addClass('has-danger-color');
            $n2g_label.addClass('has-danger-color');
            e.preventDefault();
        } else {
            $n2g_privacy.removeClass('has-danger-color');
            $n2g_label.removeClass('has-danger-color');
        }
    });


    // check for overlay
    let $fsOverlay = $('#fs-overlay');
    if ($fsOverlay.length) {
        // check for cookie
        let cookieSuffix = $fsOverlay.data('cookie-suffix');
        if (Cookie.get(`fs_overlay_${cookieSuffix}`) !== undefined) return;

        // data-fancybox
        $.fancybox.open({
            src: '#fs-overlay',
            type: 'inline',
            onActivate: function (instance, slide) {
                $('html').addClass('is-clipped');
            },
            afterClose: function (instance, slide) {
                $('html').removeClass('is-clipped');

                // $('html').removeClass('is-clipped');
                Cookie.set(`fs_overlay_${cookieSuffix}`, '1');
            },
        });

    }

});
